import { Screens } from 'src/app/core/enums/role-permissions.enum';

export interface SideNavIcon {
  icon?: string;
  displayText: string;
  iconType: SideNavType;
  route: Screens;
}

export const LOGOUT_ICON = 'assets/sidebar-icons/logout.svg';

export enum SideNavType {
  ROUTE,
  SUB_ROUTE,
  DISPLAY_ONLY,
}

const ADMIN_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.ADMIN_SEARCH,
    displayText: $localize`Admin Search`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.USER_ADMIN,
    displayText: $localize`User Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.LOCATION_ADMIN,
    displayText: $localize`Location Admin`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.LOCATION_GROUP,
    displayText: $localize`Location Group`,
    iconType: SideNavType.SUB_ROUTE,
  },
  // TODO commenting until we get this screen ready
  // {
  //   route: Screens.MAINTENANCE,
  //   displayText: $localize`Maintenance`,
  //   iconType: SideNavType.SUB_ROUTE,
  // },
];

const ARRIVE_DEPART_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.ARRIVE,
    displayText: $localize`Arrive`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.DEPART,
    displayText: $localize`Depart`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const REVENUE_RECOVERY_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.ADDITIONAL_HANDLING,
    displayText: $localize`Additional Handling`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.SIZE_AUDIT,
    displayText: $localize`Size Audit`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.WEIGHT_AUDIT,
    displayText: $localize`Weight Audit`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.WWEF,
    displayText: $localize`WWEF`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const INBOUND_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.INBOUND_SCAN,
    displayText: $localize`Inbound Scan`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.ENHANCED_INBOUND_SCAN,
    displayText: $localize`Enhanced Inbound Scan`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.WAREHOUSE_SCAN,
    displayText: $localize`Warehouse Scan`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.WAREHOUSE_OUTBOUND,
    displayText: $localize`Warehouse Outbound`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.CROSS_REFERENCE,
    displayText: $localize`Cross Reference`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const OPERATIONS_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.OUTBOUND_SCAN,
    displayText: $localize`Outbound Scan GLE`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.END_OUTBOUND_SCAN,
    displayText: $localize`End of Outbound GLE`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.CLEAR_SECURITY_SCAN,
    displayText: $localize`Clear Security Scan`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.INTERCEPTS,
    displayText: $localize`Intercepts`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.ACTIVE_CARRY_OVER_LOADS,
    displayText: $localize`Active Carry Over Loads`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const CUSTOMER_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.LOAD_TRANSFER,
    displayText: $localize`Load Transfer`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.REPROCESS_EDI,
    displayText: $localize`Reprocess EDI`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.REPROCESS_CVIS,
    displayText: $localize`Reprocess CVIS`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

const SCI_SUB_VALUES: SideNavIcon[] = [
  {
    route: Screens.SHIPPER_CONFIG,
    displayText: $localize`Shipper Config Info`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.EDI_SWAP,
    displayText: $localize`EDI SWAP`,
    iconType: SideNavType.SUB_ROUTE,
  },
  {
    route: Screens.CVIS_SWAP,
    displayText: $localize`CVIS Swap`,
    iconType: SideNavType.SUB_ROUTE,
  },
];

export const CLOSED_SIDENAV_VALUES: SideNavIcon[] = [
  {
    displayText: $localize`Dashboard`,
    icon: 'assets/sidebar-icons/home.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.DASHBOARD,
  },
  {
    displayText: $localize`Admin`,
    icon: 'assets/sidebar-icons/people.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ADMIN,
  },
  {
    displayText: $localize`Arrive/Depart`,
    icon: 'assets/sidebar-icons/airline_stops.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ARRIVE_DEPART,
  },
  {
    displayText: $localize`Revenue Recovery`,
    icon: 'assets/sidebar-icons/scale.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.REVENUE_RECOVERY,
  },
  {
    displayText: $localize`Inbound`,
    icon: 'assets/sidebar-icons/move_to_inbox.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.INBOUND,
  },
  {
    displayText: $localize`Position Based Ops`,
    icon: 'assets/sidebar-icons/truck.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.OPERATIONS,
  },
  {
    displayText: $localize`Customer`,
    icon: 'assets/sidebar-icons/person.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.CUSTOMER,
  },
  {
    displayText: $localize`SCI`,
    icon: 'assets/sidebar-icons/swap_calls.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.SCI,
  },
  {
    displayText: $localize`Messaging`,
    icon: 'assets/sidebar-icons/speech.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.MESSAGES,
  },
  {
    displayText: $localize`Reports`,
    icon: 'assets/sidebar-icons/file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.REPORTS,
  },
];

export const OPEN_SIDENAV_VALUES: SideNavIcon[] = [
  {
    displayText: $localize`Dashboard`,
    icon: 'assets/sidebar-icons/home.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.DASHBOARD,
  },
  {
    displayText: $localize`Admin`,
    icon: 'assets/sidebar-icons/people.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ADMIN,
  },
  ...ADMIN_SUB_VALUES,
  {
    displayText: $localize`Arrive/Depart`,
    icon: 'assets/sidebar-icons/airline_stops.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.ARRIVE_DEPART,
  },
  ...ARRIVE_DEPART_SUB_VALUES,
  {
    displayText: $localize`Revenue Recovery`,
    icon: 'assets/sidebar-icons/scale.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.REVENUE_RECOVERY,
  },
  ...REVENUE_RECOVERY_SUB_VALUES,
  {
    displayText: $localize`Inbound`,
    icon: 'assets/sidebar-icons/move_to_inbox.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.INBOUND,
  },
  ...INBOUND_SUB_VALUES,
  {
    displayText: $localize`Position Based Ops`,
    icon: 'assets/sidebar-icons/truck.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.OPERATIONS,
  },
  ...OPERATIONS_SUB_VALUES,
  {
    displayText: $localize`Customer`,
    icon: 'assets/sidebar-icons/person.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.CUSTOMER,
  },
  ...CUSTOMER_SUB_VALUES,
  {
    displayText: $localize`SCI`,
    icon: 'assets/sidebar-icons/swap_calls.svg',
    iconType: SideNavType.DISPLAY_ONLY,
    route: Screens.SCI,
  },
  ...SCI_SUB_VALUES,
  {
    displayText: $localize`Messaging`,
    icon: 'assets/sidebar-icons/speech.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.MESSAGES,
  },
  {
    displayText: $localize`Reports`,
    icon: 'assets/sidebar-icons/file.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.REPORTS,
  },
  {
    displayText: $localize`Logout`,
    icon: 'assets/sidebar-icons/logout.svg',
    iconType: SideNavType.ROUTE,
    route: Screens.LOGOUT,
  },
];
